// @flow

import React, { useState, type Node } from 'react';
import styled from 'styled-components';
import { Button as RootButton } from '../../../../atoms';
import { getSafeFawryInfo, useIncomingPayment } from '../../../../../../prs/incoming-payment';
import { translate } from '@tectonics/translate';

export function ReferenceNumber(): Node {
  const incomingPayment = useIncomingPayment();
  const fawryInfo = getSafeFawryInfo(incomingPayment);
  const [copyText, setCopyText] = useState(translate('volcanes.opened-payment.fawry.referenceNumber.copy'));

  const onClickToCopy = () => {
    navigator.clipboard.writeText(fawryInfo.reference_number)
      .then(() => {
        setCopyText(translate('volcanes.opened-payment.fawry.referenceNumber.copied'));
        setTimeout(() => setCopyText(translate('volcanes.opened-payment.fawry.referenceNumber.copy')), 5000);
      });
  };

  return (
    <>
      <Text>{translate('volcanes.opened-payment.fawry.referenceNumber.title')}</Text>
      <TextReferenceNumber id="referenceNumberValue">{fawryInfo.reference_number}</TextReferenceNumber>
      <Button id="buttonToCopy" onClick={onClickToCopy} type="primary" flat outline rounded>{copyText}</Button>
    </>
  );
}

const Text = styled.div`
  font-size: 0.9em;
  font-family: ${props => props.theme.fontFamily.display};
`;

const TextReferenceNumber = styled.dd`
  font-size: 20px;
  font-weight: 800;
  color: ${props => props.redesign !== false ? props.theme.colors.secondaryGray : props.theme.colors.black};
  text-align: baseline;
`;

const Button = styled(RootButton)`
  min-width: 170px;
`;
